import { axiosECS } from "services/baseAxios";

const path = "/v2/credentials";

export const getMCEKey = async (): Promise<{ data: string }> => {
  return axiosECS.get(`${path}/mce-key`);
};
